import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import type { BillingRefusal } from "@onetasklist/shared";
import { useUpgradePromptViewModel } from "./UpgradePrompt.ViewModel";
import { useUpgradePromptText } from "./UpgradePrompt.i18n";

interface UpgradePromptProps {
  /** What billing refused; null keeps the prompt closed. */
  refusal: BillingRefusal | null;
  onDismiss: () => void;
}

/** Shown wherever the plan refuses a board or a connection (402), or billing can't check it (503). */
const UpgradePrompt: React.FC<UpgradePromptProps> = ({ refusal, onDismiss }) => {
  const vm = useUpgradePromptViewModel(refusal, onDismiss);
  const text = useUpgradePromptText(vm);

  return (
    <Dialog
      open={vm.isOpen}
      onOpenChange={(_, data) => {
        if (!data.open) vm.dismiss();
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{text.title}</DialogTitle>
          <DialogContent>{text.body}</DialogContent>
          <DialogActions>
            {vm.isPlanLimit ? (
              <>
                <Button appearance="secondary" onClick={vm.dismiss}>
                  {text.notNow}
                </Button>
                <Button appearance="primary" onClick={vm.seePlans}>
                  {text.seePlans}
                </Button>
              </>
            ) : (
              <Button appearance="primary" onClick={vm.dismiss}>
                {text.close}
              </Button>
            )}
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default UpgradePrompt;
